<div class="cv-loader" [class.active]="isLoading$ | async">
	<div [ngClass]="loaderClass"></div>
</div>
